import Vue from "vue"
import {capitalize} from "@/utility/data/strings"

Vue.filter("capitalize", (value: string | null) => {
	if (!value) return ""
	return capitalize(value.toString())
})
